module.exports = __webpack_public_path__ + "static/media/UEM_logo.441ae17c.webp";